import { __decorate as t, __classPrivateFieldGet as r, __classPrivateFieldSet as e } from "tslib";
import { LitElement as i, html as o } from "lit";
import { property as s } from "lit/decorators.js";
import a from "@inera/ids-design/components/mobile-menu/mobile-menu-lit.js";
var n;
class m extends i {
  constructor() {
    super(...arguments), n.set(this, 1);
  }
  get variation() {
    return r(this, n, "f");
  }
  set variation(t) {
    e(this, n, t, "f");
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.querySelectorAll("ids-mobile-menu-item")?.forEach(t => {
      t.setAttribute("variation", "" + this.variation);
    });
  }
  render() {
    return o`<ids-row><slot></slot></ids-row>`;
  }
}
n = new WeakMap(), m.styles = [a], t([s({
  type: Number
})], m.prototype, "variation", null);
export { m as IDSMobileMenu };